<div [class]="getElementClasses()" ngClass="widtget-editor-text" [innerHTML]="widget?.Texto"></div>
